import React from 'react';
import { reduxForm, Field } from 'redux-form';
import MenuTitle from 'components/MenuTitle';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import { ActionBarWrapper } from 'components/wrappers/pages';
import { onClickAddBank, onChangeKeyword } from 'actions/setting/bankAccount';
import styles from './ActionBar.css';

class ActionBar extends React.Component {
  render() {
    return (
      <div>
        <span style={{ paddingLeft: 0 }}>
          <MenuTitle menuTitle="Bank Account" />
        </span>
        <div
          className="col-sm-2 hidden-xs col-md-6 action-bank-account"
          style={{ paddingRight: 0 }}
        >
          <span className="pull-right">
            <button
              className="btn btn-primary ml-10px"
              onClick={this._onClickCreateBankAccount}
            >
              Add Bank
            </button>
          </span>
        </div>
        <ActionBarWrapper>
          <div className="col-sm-12 col-xs-12" style={{ paddingLeft: 0 }}>
            <form className={`form-inline ${styles['action-bar']}`}>
              <div className="form-group mr-5px">
                <Field
                  component={SearchBar}
                  name="keyword"
                  onChange={this._onChangeKeyword}
                  placeholder="Search"
                />
              </div>
            </form>
          </div>
        </ActionBarWrapper>
      </div>
    );
  }

  _onClickCreateBankAccount = () => {
    const { dispatch } = this.props;
    dispatch(onClickAddBank(1));
  };

  _onChangeKeyword = (event, keyword) => {
    this.props.dispatch(onChangeKeyword(keyword));
  };
}

const mapForm = {
  form: 'search',
};

export default reduxForm(mapForm)(ActionBar);
